<template>
  <div class="search-box">
    <div class="search-header"> 
      <div class="search-input">
        <input type="text" v-model="searchPhone" maxlength="11" placeholder="请输入手机号进行查询">
      </div>
      <div class="search-btn" @click="searchResult">
        <img src="@/assets/loading.png" v-show="searchLoading">
        <span>查询</span>
      </div>
    </div>
    <div class="search-result">
      <div class="search-result-inner">

        <div class="result-number">共查询到 {{resultTotal}} 条记录</div>
        
        <div class="result-list" 
          v-show="resultData.length > 0 && isSearched"
          v-for="item in resultData" 
          :key="item.id">
          <div class="result-item">
            <div class="title gray">姓名</div>
            <div class="text">{{item.name}}</div>
          </div>
          <div class="result-item">
            <div class="title gray">电话</div>
            <div class="text">{{item.phoneNumber}}</div>
          </div>
          <div class="result-item">
            <div class="title gray">邮箱</div>
            <div class="text">{{item.email}}</div>
          </div>
          <div class="result-item">
            <div class="title gray">场次</div>
            <div class="text">{{item.schedule.scheduleDate + ' ' + item.schedule.startTime + ' ' + item.schedule.remark}}</div>
          </div>
          <div class="result-item">
            <div class="title gray">岗位</div>
            <div class="text">{{getTableJobs(item.schedule.posts)}}</div>
          </div>
          <div class="result-item" style="border-bottom: 0px">
            <div class="title gray">状态</div>
            <div v-show="item.schedule.active == 0" class="text error">预约场次已被取消,请重新预约</div>
            <div class="text yellow" v-show="item.bookingStatus == 0 && item.schedule.active == 1">待审核</div>
            <div class="text error" v-show="item.bookingStatus == 1 && item.schedule.active == 1">未通过审核</div>
            <div class="text success" v-show="item.bookingStatus == 2 && item.schedule.active == 1">审核通过</div>
            <div class="text success" v-show="item.bookingStatus == 3 && item.schedule.active == 1">笔试完成</div>
            <div class="text error" v-show="item.bookingStatus == 4 && item.schedule.active == 1">预约已取消</div>
          </div>
        </div>

        <div class="no-result gray" v-show="!isSearched">
          <div>
            <img src="@/assets/info.png" alt="" srcset="">
          </div>
          <div class="primary">请输入手机号后进行查询</div>
        </div>
        
        <div class="no-result" v-show="resultData.length == 0 && isSearched">
          <div>
            <img src="@/assets/error-result.png" alt="" srcset="">
          </div>
          <div class="primary">抱歉，未查询到该手机号关联的预约信息</div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Search',
  components: { },
  data() {
    return {
      searchLoading: false,
      resultData: [],
      searchPhone: '',
      resultTotal: 0,
      isSearched: false
    };
  },
  mounted () {
   
  },
  methods: {
    getTableJobs(arr) {
      var text = ''
      arr.forEach((item, index) => {
        var symbol = index == 0?'':'、'
        text+=symbol + item.postName
      })
      return text || '-'
    },
    searchResult () {
      var that = this
      if(!(/^1[3456789]\d{9}$/.test(that.searchPhone))){ 
        that.$message({
          type: 'success',
          text: '手机号格式不正确',
        });
        return false; 
      }
      that.resultData = []
      that.resultTotal = 0
      that.searchLoading = true
      that.$http(
        '/user/Booking/GetBookings', 
        {
          "phoneNumber": that.searchPhone,
          "pageIndex": 1,
          "pageSize": 1000,
        }
      )
      .then(function (res) {
        if(res.messageLevel == 1){
          that.searchLoading = false
          that.resultData = res.data
          that.resultTotal = res.data.length
        }else{
          that.$message({
            type: 'success',
            text: res.message
          });
          that.searchLoading = false
        }
        that.isSearched = true
      })
      .catch(function (error) {
        that.searchLoading = false
        that.$message({
          type: 'success',
          text: error.message,
        })
      })
    }
  }
}
</script>
<style scoped>
  .search-box{
    background: #F5F5F5;
    min-height: 100vh;
  }
  .search-input{
    background: #EDEDED;
    float: left;
    border-radius: 100px;
    width: 70%;
    margin-right: 10px;
    line-height: 32px;
  }
  .search-input input{
    background: #EDEDED;
    border-radius: 100px;
    border: 0;
    outline: 0;
    font-size: 15px;
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }
  .search-btn{
    background: #3296FF;
    color: #fff;
    font-size: 14px;
    float: left;
    width:calc(30% - 10px);
    border-radius: 100px;
    line-height: 32px;
  }
   .search-btn:active{
    background: #0075F0;
  }
  .search-header{
    width: calc(100% - 24px);
    margin: 0 auto;
    padding: 16px 0;
    height: 32px;
  }
  .search-result{
    width: calc(100% - 24px);
    margin: 0 auto;
    padding-bottom: 20px;
  }
  .search-result-inner{
    background: #fff;
    min-height: calc(100vh - 96px);
    margin: 0 auto;
    border-radius: 4px;
  }
  .no-result{
    font-size: 15px;
  }
  .no-result img{
    width: 52px;
    height: 52px;
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .no-result{
    padding-top: calc(20vh);
  }
  .result-number{
    text-align: left;
    font-size: 13px;
    padding: 12px;
    border-bottom: 1px solid #F2F6FC;
  }
  .result-item{
    display: flex;
    /* line-height: 44px; */
    padding: 12px 0;
    font-size: 15px;
    border-bottom: 1px solid #F2F6FC;
  }
  .result-item .title {
    min-width: 36px;
  }
  .result-item .text{
    flex: auto;
    text-align: right;
  }
  .result-item .text.success{
    color: #00C32C;
  }
  .result-item .text.error{
    color: #ff0000;
  }
  .result-item .text.yellow{
    color: #FFAF32;
  }
  .result-list{
    padding: 12px;
  }
  .result-list+.result-list{
    border-top: 1px solid #eaeaea;
  }
  .search-btn img{
    width: 14px;
    height: 14px;
    margin-right: 8px;
    animation: rotate 2s linear infinite;
    display: inline-block;
    vertical-align: middle;
  }
  .search-btn span{
    display: inline-block;
    vertical-align: middle;
  }
  @keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(359deg)}
  }
</style>

